import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function N() {
    const { useLang } = useGlobal();
    const { t } = useLang('productriver2');

    return (
        <div className={`${css.N_14} river2_detials_N`}>
            <p>{t('river2.details.sec14_note')}</p>
        </div>
    );
}
